
UP = 38
DOWN = 40
ENTER = 13
TAB = 9
ESC = 27


findParent = (element, names...) ->
    parent = element.parent()
    for name in names
        controller = parent.controller(name)
        if controller? then return controller
    return null


class dybFieldController

    ### @ngInject ###
    constructor: ($injector, $scope, $element, $timeout, $attrs) ->

        @injector = $injector
        @scope = $scope
        @element = $element
        @attrs = $attrs
        @timeout = $timeout

        if not @name? then throw new Error('No Name')

        @parent = findParent($element, 'dybSubForm', 'dybForm')
        @form = $element.controller('dybForm')

        if not @formData? then @refreshData()

        @parent.addControl(@)
        @scope.$on('$destroy', @$destroy)
        @scope.$watch((=> @classes), @watchClasses, true)

        @modelDebounce =
            updateOn: 'default blur',
            debounce: 'default': 500, 'blur': 0


    Object.defineProperties @prototype,

        name: get: -> @attrName or @config?.name
        label: get: -> @attrs.label or @config?.question or @config?.label
        helpText: get: -> @attrs.helpText or @config?.helpText or @config?.help_text

        viewData:
            get: -> @scope.data

        formData:
            get: -> @parent.getFormData(@)
            set: (value) -> @parent.setFormData(@, value)

        isEmpty:
            get: -> not @activeData? or @activeData == ""

        activeData:
            get: -> if @form.isOpen then @formData else @viewData

        isFocused:
            get: -> @_isFocused
            set: (value) ->
                @_isFocused = !!value
                @element.toggleClass('focused', @_isFocused)

        isRequired:
            get: ->
                if not @attrs.required? then return false
                if @attrs.required == "" then return true
                return @required field: @

        hasIssue:
            get: ->
                if @attrs.issueWhen
                    issue = @issueEval
                        value: @activeData
                        isEmpty: @isEmpty
                        field: @
                    return issue
                else
                    @isEmpty

        hasChanged:
            get: -> @form.isOpen && @formData != @viewData

        isValid:
            get: -> @ngModel?.$valid

        ngModel:
            get: -> @parent.ngForm[@name]

        classes:
            get: ->
                'empty': @isEmpty
                'not-empty': !@isEmpty
                'has-issue': @hasIssue
                'no-issue': !@hasIssue
                'valid': @isValid
                'invalid': !@isValid
                'valid': @isValid

    $destroy: =>
        @parent.removeControl(@)
        return

    refreshData: ->
        @formData = angular.copy(@viewData)
        return

    openForm: (focusContext) ->
        @form.open().then(=> @timeout(=> @focus(focusContext)))
        if @attrs.asyncValidate
            if angular.isFunction(@asyncValidate)
                @asyncValidate = async: @asyncValidate
            @ngModel.$asyncValidators[name] = fn for name, fn of @asyncValidate
        return

    focus: (context) =>
        @focusFirst("input", true)
        @focusFirst("textarea")

    focusFirst: (tag, select) ->
        element = @element.find(tag)[0]
        if element? then element.focus()
        if element? and select then element.select()
        return

    pickClass: (value, trueClass, falseClass) ->
        @element.toggleClass(trueClass, !!value)
        @element.toggleClass(falseClass, !value)

    watchClasses: (classes) =>
        for className, enabled of classes
            @element.toggleClass(className, !!enabled)
        return

    dispatchOnChange: ->
        @onChange({$value: @formData})

    toJSON: ->
        viewData: @viewData
        formData: @formData
        activeData: @activeData
        isEmpty: @isEmpty


class NumberFieldController extends dybFieldController

    units: ->
        if not @attrs.unit then ""
        else if not @activeData? then @attrs.unit
        else if @activeData == 1 then @attrs.unit.replace('(s)', '')
        else return @attrs.unit.replace('(s)', 's')

    Object.defineProperties @prototype,
        changeAmt:
            get: -> if @hasChanged then @formData - @viewData else 0
        changeMag:
            get: -> Math.abs(@changeAmt)


class OptionFieldController extends dybFieldController

    Object.defineProperties @prototype,
        options: get: -> @scope.options or @config?.options or []

    openForm: (event, value) ->
        if not @form.isOpen then event.preventDefault()
        super value

    focus: (context) ->
        if not @formData? then @formData = context
        @focusFirst('input')

    getOptionValue: (option) ->
        getter = @scope.optionValueGetter
        if getter? then getter(option) else option


class YesNoFieldController extends OptionFieldController


class DropdownFieldController extends dybFieldController

    ### @ngInject ###
    constructor: ($injector, $scope, $element, $timeout, $attrs) ->
        super($injector, $scope, $element, $timeout, $attrs)
        @document = $injector.get('$document')
        @element.bind("keydown", @keydown)

    openDropdown: =>
        @isFocused = true
        @dropdownOpen = true
        @element.addClass('dropdown-open')
        @document.bind('mousedown', @documentClick)
        return

    closeDropdown: =>
        @dropdownOpen = false
        @element.removeClass('dropdown-open')
        @document.bind('unbind', @documentClick)
        return

    apply: (fn) -> @scope.$apply(fn)

    documentClick: (event) =>
        if not @element[0].contains(event.target)
            @apply @closeDropdown

    keydown: (event) =>
        if @dropdownOpen and event.which in [ENTER, ESC, TAB]
            @apply @closeDropdown
            if event.which == ENTER then event.preventDefault()
        else if not @dropdownOpen and event.which == DOWN
            @apply @openDropdown()
            event.preventDefault()


class DateFieldController extends DropdownFieldController

    ### @ngInject ###
    constructor: ($injector, $scope, $element, $timeout, $attrs) ->
        super($injector, $scope, $element, $timeout, $attrs)
        @moment = $injector.get('moment')

    closeDropdown: =>
        super()
        @reformatDate()

    blur: ->
        @isFocused = false
        @reformatDate()

    clickDate: ->
        if @formData then @formData = @moment(@formData)
        @dispatchOnChange()
        @closeDropdown()

    today: ->
        @formData = @moment()
        @reformatDate()
        @dispatchOnChange()
        return

    clear: ->
        @formData = null
        @reformatDate()
        @dispatchOnChange()
        return

    cancel: ->
        @refreshData()
        @reformatDate()
        @dispatchOnChange()
        @closeDropdown()

    reformatDate: ->
        if @formData and @formData.clone then @formData = @formData.clone()


class ValueSearchController extends DropdownFieldController

    refreshData: ->
        super()
        @searchText = if @formData?.name? then @formData.name else ""
        @searchChanged = false

    clear: =>
        @searchText = ""
        @formData = undefined
        @closeDropdown()

    openDropdown: ->
        super()
        @updateList()

    closeDropdown: ->
        super()

        if @searchText == '' and not @formData
            @formData = undefined
            @searchChanged = false
            return

        else if @selectedIndex == -1 and @searchChanged
            @selectByIndex(0)

        @searchChanged = false
        @searchText = if @formData? then @formData.name else ""

    updateList: (query) =>
        @selectedIndex = -1
        @element.find('ul')[0]?.scrollTop = 0
        if not @dropdownOpen then @openDropdown()
        if query? then @searchChanged = true
        @scope.doSearch({query: query})
            .then (items) => @staff = items

    keydown: (event) =>
        if @dropdownOpen and event.which in [UP, DOWN]
            event.preventDefault()
            @scope.$apply =>
                @selectedIndex += event.which - (UP + 1)
                @selectByIndex(@selectedIndex)
            return
        super(event)

    selectByIndex: (index) ->
        index = Math.min(@staff.length - 1, Math.max(0, index))
        @selectedIndex = index
        @formData = @staff[index]
        list = @element.find('ul')[0]
        if list
            items = list.children
            item_offset = items[index].offsetTop + items[index].offsetHeight
            list.scrollTop = item_offset - list.offsetHeight

    listClick: (index) =>
        @selectByIndex(index)
        @closeDropdown()


extendScope = (scope) ->
    scope.data = '=value'
    return scope


makeFieldDirective = (type, controller=dybFieldController, scope={}) ->
    capitalized = type[0].toUpperCase() + type.slice(1)
    directiveName = "dyb#{capitalized}Field"

    module.directive(directiveName, ->
        restrict: 'E'
        require: ['^dybForm', directiveName]
        templateUrl: "forms/#{type}Field"
        scope: extendScope(scope)
        controllerAs: 'ctrl'
        controller: controller
        transclude:
            messages: '?ngMessage'
            label: '?radioLabel'
            help: '?helpText'

        bindToController:
            issueEval: '&issueWhen'
            required: '&'
            config: '='
            onChange: '&'
            asyncValidate: '='
            attrName: '@?name'

        link: (scope, element, attrs, controllers) ->
            [dybForm, ctrl] = controllers
            element.addClass "dyb-field"
            element.addClass "dyb-field-#{type}"
            scope.type = type
            return
    )

makeFieldDirective "text"
makeFieldDirective "textarea"
makeFieldDirective "number", NumberFieldController,
    min: '='
    max: '='

makeFieldDirective "yesNo", YesNoFieldController
makeFieldDirective "checkbox"
makeFieldDirective 'select', OptionFieldController,
    options: '='
    optionValueGetter: '=?'
makeFieldDirective "radios", OptionFieldController,
    options: '='
    optionValueGetter: '=?'

makeFieldDirective 'date', DateFieldController
makeFieldDirective 'time'

makeFieldDirective 'ybusaStaff', ValueSearchController,
    doSearch: '&search'


module.directive 'dybFieldTranscludeProxy', ->
    restrict: 'A'
    link: (scope, element, attrs, controller, transclude) ->
        if not transclude then return

        definitions = {}

        for name in attrs.dybFieldTranscludeProxy.split(',')
            definitions[name] = get: -> scope[name]

        Object.defineProperties scope.$$childHead, definitions

        return
